// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Similar to .is-hover-visible, but elements are hidden in a way that they do not consume space in the layout.
 *
 * Note: This toggles between \`display: initial\` and \`display: none\`. Other values are currently not supported.
 *
 * Caution: This (intentionally) causes layout jank.
 * Use this utility only if required by the design, otherwise use .is-hover-visible.
 */
@media (hover: hover) {
  .is-hover-displayed {
    :not(
        :is(.d-hover-context:is(:hover, .is-hover-active) &, :host(.d-hover-context:is(:hover, .is-hover-active)) &)
      )& {
      display: var(--is-keynav, none);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/utils/is-hover-displayed.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;AACF;EACE;IACE;;;MAGE,+BAA+B;IACjC;EACF;AACF","sourcesContent":["/**\n * Similar to .is-hover-visible, but elements are hidden in a way that they do not consume space in the layout.\n *\n * Note: This toggles between `display: initial` and `display: none`. Other values are currently not supported.\n *\n * Caution: This (intentionally) causes layout jank.\n * Use this utility only if required by the design, otherwise use .is-hover-visible.\n */\n@media (--hover) {\n  .is-hover-displayed {\n    :not(\n        :is(.d-hover-context:is(:hover, .is-hover-active) &, :host(.d-hover-context:is(:hover, .is-hover-active)) &)\n      )& {\n      display: var(--is-keynav, none);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
